import type { CSSObject, SerializedStyles, Theme } from '@emotion/react';

type TextProps = {
  textColor?: TextColor;
  inline?: boolean;
  className?: string;
};

type StyledTextProps = {
  textColor?: TextColor;
};

type TextColor =
  | 'default'
  | 'green'
  | 'grey'
  | 'white'
  | 'orange'
  | 'darkerOrange'
  | 'error'
  | 'current';

type TextSize = 'normal' | 'small' | 'xs';

const mapColor = (theme: Theme, color: TextColor = 'default') =>
  ({
    default: theme.colors.neutral.grey160,
    green: theme.colors.brand.green100,
    grey: theme.colors.neutral.grey140,
    white: theme.colors.neutral.white100,
    orange: theme.colors.brand.orange100,
    darkerOrange: theme.colors.brand.orange120,
    error: theme.colors.accent.red100,
    current: 'currentcolor',
  })[color];

type StyledHeadingProps = StyledTextProps & {
  resetSpacing?: boolean;
  overrideStyles?: SerializedStyles | CSSObject;
};

export { mapColor };
export type {
  TextColor,
  TextSize,
  TextProps,
  StyledHeadingProps,
  StyledTextProps,
};
